// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"dd175704","container":"ffb53aae","titleContainer":"a6449b06","title":"f9c5288e","contentContainer":"ce42a342"};